// extracted by mini-css-extract-plugin
export default {"wrapper":"RemoveSpaceModal_wrapper__CMaO6","formControl":"RemoveSpaceModal_formControl__0Oztq","action":"RemoveSpaceModal_action__Gbqt0"};